// extracted by mini-css-extract-plugin
export default {"root":"root--NFbFV","selected":"selected--_5942","error":"error--_JJ6o","badge":"badge--r_zST","tabWrapper":"tabWrapper--_wop3"};